<template>
  <div id="wrapper">
    <div
      id="header"
      :style="{
        backgroundImage:
          'url(' + require('../../assets/images/Rectangle-13.png') + ')'
      }"
    >
      <h1>{{ $t("history.title") }}</h1>
    </div>
    <Submenu
      :submenuItems="submenuItems"
      :selectedItem="selectedItem"
      basePath="history-section"
      v-on:changeItem="changeItem"
    />
    <div id="content" class="w-container">
      <transition name="change" mode="out-in">
        <FirstPage v-if="selectedItem === 'history'" />
        <Members v-if="selectedItem === 'members'" />
        <Vestimentation v-if="selectedItem === 'clothing'" />
        <Discography v-if="selectedItem === 'discography'" />
      </transition>
    </div>
  </div>
</template>

<script>
import FirstPage from "./FirstPage";
import Members from "./Members";
import Vestimentation from "./Vestimentation";
import Discography from "./Discography";
import Submenu from "../Submenu";

export default {
  name: "History",
  components: {
    FirstPage,
    Members,
    Vestimentation,
    Discography,
    Submenu
  },
  data() {
    return {
      submenuItems: [
        {
          id: "history",
          value: this.$t("history.shortHistory")
        },
        {
          id: "members",
          value: this.$t("history.members")
        },
        {
          id: "clothing",
          value: this.$t("history.clothing")
        },
        {
          id: "discography",
          value: this.$t("history.discography")
        }
      ],
      selectedItem: "history"
    };
  },
  methods: {
    changeItem: function(item) {
      this.selectedItem = item.id;
    }
  },
  mounted() {
    this.selectedItem = this.$route.params.section || "history";
  }
};
</script>

<style scoped lang="scss">
#header {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: cover;
}

#header > h1 {
  font-family: Roboto, sans-serif;
  font-size: 5.3em;
  line-height: 1.2em;
  text-transform: uppercase;
  color: white;
}

.change-enter-active,
.change-leave-active {
  transition: 0.3s;
}

.change-enter,
.change-leave-to {
  opacity: 0;
}

#wrapper {
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
}

#content {
  padding: 7vh 10px;
}

.w-container {
  max-width: 820px;
  width: 100%;
}

@media (max-width: 476px) {
  #header h1 {
    font-size: 3.5em;
    font-weight: 700;
  }
}
</style>
